/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers"
import { Provider, TransactionRequest } from "@ethersproject/providers"
import type { ERC20Upgradeable, ERC20UpgradeableInterface } from "../ERC20Upgradeable"

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
]

const _bytecode =
  "0x608060405234801561001057600080fd5b506113d8806100206000396000f3fe608060405234801561001057600080fd5b50600436106100a95760003560e01c80633950935111610071578063395093511461016857806370a082311461019857806395d89b41146101c8578063a457c2d7146101e6578063a9059cbb14610216578063dd62ed3e14610246576100a9565b806306fdde03146100ae578063095ea7b3146100cc57806318160ddd146100fc57806323b872dd1461011a578063313ce5671461014a575b600080fd5b6100b6610276565b6040516100c39190610e44565b60405180910390f35b6100e660048036038101906100e19190610c92565b610308565b6040516100f39190610e29565b60405180910390f35b610104610326565b6040516101119190610f46565b60405180910390f35b610134600480360381019061012f9190610c43565b610330565b6040516101419190610e29565b60405180910390f35b610152610431565b60405161015f9190610f61565b60405180910390f35b610182600480360381019061017d9190610c92565b61043a565b60405161018f9190610e29565b60405180910390f35b6101b260048036038101906101ad9190610bde565b6104e6565b6040516101bf9190610f46565b60405180910390f35b6101d061052f565b6040516101dd9190610e44565b60405180910390f35b61020060048036038101906101fb9190610c92565b6105c1565b60405161020d9190610e29565b60405180910390f35b610230600480360381019061022b9190610c92565b6106b5565b60405161023d9190610e29565b60405180910390f35b610260600480360381019061025b9190610c07565b6106d3565b60405161026d9190610f46565b60405180910390f35b606060368054610285906110aa565b80601f01602080910402602001604051908101604052809291908181526020018280546102b1906110aa565b80156102fe5780601f106102d3576101008083540402835291602001916102fe565b820191906000526020600020905b8154815290600101906020018083116102e157829003601f168201915b5050505050905090565b600061031c61031561075a565b8484610762565b6001905092915050565b6000603554905090565b600061033d84848461092d565b6000603460008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600061038861075a565b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905082811015610408576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016103ff90610ec6565b60405180910390fd5b6104258561041461075a565b85846104209190610fee565b610762565b60019150509392505050565b60006012905090565b60006104dc61044761075a565b84846034600061045561075a565b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020546104d79190610f98565b610762565b6001905092915050565b6000603360008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b60606037805461053e906110aa565b80601f016020809104026020016040519081016040528092919081815260200182805461056a906110aa565b80156105b75780601f1061058c576101008083540402835291602001916105b7565b820191906000526020600020905b81548152906001019060200180831161059a57829003601f168201915b5050505050905090565b600080603460006105d061075a565b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205490508281101561068d576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161068490610f26565b60405180910390fd5b6106aa61069861075a565b8585846106a59190610fee565b610762565b600191505092915050565b60006106c96106c261075a565b848461092d565b6001905092915050565b6000603460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905092915050565b600033905090565b600073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1614156107d2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016107c990610f06565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610842576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161083990610e86565b60405180910390fd5b80603460008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925836040516109209190610f46565b60405180910390a3505050565b600073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16141561099d576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161099490610ee6565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610a0d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a0490610e66565b60405180910390fd5b610a18838383610baf565b6000603360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905081811015610a9f576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a9690610ea6565b60405180910390fd5b8181610aab9190610fee565b603360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555081603360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254610b3d9190610f98565b925050819055508273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef84604051610ba19190610f46565b60405180910390a350505050565b505050565b600081359050610bc381611374565b92915050565b600081359050610bd88161138b565b92915050565b600060208284031215610bf057600080fd5b6000610bfe84828501610bb4565b91505092915050565b60008060408385031215610c1a57600080fd5b6000610c2885828601610bb4565b9250506020610c3985828601610bb4565b9150509250929050565b600080600060608486031215610c5857600080fd5b6000610c6686828701610bb4565b9350506020610c7786828701610bb4565b9250506040610c8886828701610bc9565b9150509250925092565b60008060408385031215610ca557600080fd5b6000610cb385828601610bb4565b9250506020610cc485828601610bc9565b9150509250929050565b610cd781611034565b82525050565b6000610ce882610f7c565b610cf28185610f87565b9350610d02818560208601611077565b610d0b8161113a565b840191505092915050565b6000610d23602383610f87565b9150610d2e8261114b565b604082019050919050565b6000610d46602283610f87565b9150610d518261119a565b604082019050919050565b6000610d69602683610f87565b9150610d74826111e9565b604082019050919050565b6000610d8c602883610f87565b9150610d9782611238565b604082019050919050565b6000610daf602583610f87565b9150610dba82611287565b604082019050919050565b6000610dd2602483610f87565b9150610ddd826112d6565b604082019050919050565b6000610df5602583610f87565b9150610e0082611325565b604082019050919050565b610e1481611060565b82525050565b610e238161106a565b82525050565b6000602082019050610e3e6000830184610cce565b92915050565b60006020820190508181036000830152610e5e8184610cdd565b905092915050565b60006020820190508181036000830152610e7f81610d16565b9050919050565b60006020820190508181036000830152610e9f81610d39565b9050919050565b60006020820190508181036000830152610ebf81610d5c565b9050919050565b60006020820190508181036000830152610edf81610d7f565b9050919050565b60006020820190508181036000830152610eff81610da2565b9050919050565b60006020820190508181036000830152610f1f81610dc5565b9050919050565b60006020820190508181036000830152610f3f81610de8565b9050919050565b6000602082019050610f5b6000830184610e0b565b92915050565b6000602082019050610f766000830184610e1a565b92915050565b600081519050919050565b600082825260208201905092915050565b6000610fa382611060565b9150610fae83611060565b9250827fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff03821115610fe357610fe26110dc565b5b828201905092915050565b6000610ff982611060565b915061100483611060565b925082821015611017576110166110dc565b5b828203905092915050565b600061102d82611040565b9050919050565b60008115159050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000819050919050565b600060ff82169050919050565b60005b8381101561109557808201518184015260208101905061107a565b838111156110a4576000848401525b50505050565b600060028204905060018216806110c257607f821691505b602082108114156110d6576110d561110b565b5b50919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b6000601f19601f8301169050919050565b7f45524332303a207472616e7366657220746f20746865207a65726f206164647260008201527f6573730000000000000000000000000000000000000000000000000000000000602082015250565b7f45524332303a20617070726f766520746f20746865207a65726f20616464726560008201527f7373000000000000000000000000000000000000000000000000000000000000602082015250565b7f45524332303a207472616e7366657220616d6f756e742065786365656473206260008201527f616c616e63650000000000000000000000000000000000000000000000000000602082015250565b7f45524332303a207472616e7366657220616d6f756e742065786365656473206160008201527f6c6c6f77616e6365000000000000000000000000000000000000000000000000602082015250565b7f45524332303a207472616e736665722066726f6d20746865207a65726f20616460008201527f6472657373000000000000000000000000000000000000000000000000000000602082015250565b7f45524332303a20617070726f76652066726f6d20746865207a65726f2061646460008201527f7265737300000000000000000000000000000000000000000000000000000000602082015250565b7f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f7760008201527f207a65726f000000000000000000000000000000000000000000000000000000602082015250565b61137d81611022565b811461138857600080fd5b50565b61139481611060565b811461139f57600080fd5b5056fea26469706673582212206d992f572e5fd73aec051714c199ac13f6b3762e80a1b7f1c66f353275c502bb64736f6c63430008020033"

export class ERC20Upgradeable__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(overrides?: Overrides & { from?: string | Promise<string> }): Promise<ERC20Upgradeable> {
    return super.deploy(overrides || {}) as Promise<ERC20Upgradeable>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): ERC20Upgradeable {
    return super.attach(address) as ERC20Upgradeable
  }
  connect(signer: Signer): ERC20Upgradeable__factory {
    return super.connect(signer) as ERC20Upgradeable__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ERC20UpgradeableInterface {
    return new utils.Interface(_abi) as ERC20UpgradeableInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC20Upgradeable {
    return new Contract(address, _abi, signerOrProvider) as ERC20Upgradeable
  }
}
